import NotesItemCard from './NotesItemCard';

export default NotesItemCard;
